export default "__VITE_ASSET__Bk3ZYTVZ__"